import React from "react";
import SubmitFilters from "../components/filters/SubmitFilters";
import SearchInput from "../components/inputs/SearchInput";

const Filters = (props) => {
	return (
		<SubmitFilters {...props}>
			<SearchInput source="q" alwaysOn fullWidth />
		</SubmitFilters>
	);
};
export default Filters;
